
import MyDialog from '@/components/unit/dialog/index.js'
// 判断
export default {
    methods: {
        async login(){
        return new Promise((resolve,reject)=>{
            if(!this.$store.state.common.salesInfo.phone){
                MyDialog({link:'/page/user/loginSales.vue'}).then(res=>{
                    resolve()
                }).catch(()=>{
                    reject()
                })
            }else{
                resolve()
            }
        })

        },
    }
  }
  